export default {"src":"/_next/static/media/DownArrowTJRed.78438c39.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};